import { action } from "../common/Action"
import { ImpiantiClienteClient, SetImpiantoKeyDto } from "../generated";

const service = new ImpiantiClienteClient();

class ImpiantiClienteActions {
    @action
    async getForCustomer(idCliente: number) {
        return {
            idCliente,
            impianti: (await service.get(idCliente))!,
        }
    };
    @action
    async setGroup(idCliente: number, data: SetImpiantoKeyDto) {
        await service.setGroup(data)
        return this.getForCustomer(idCliente);
    };


}
export default new ImpiantiClienteActions();